// services/scheduleApiService.js

import { message } from "antd";
import drEasyApi from "./Customapi";

// Schedule Types Constants
export const SCHEDULE_TYPES = {
  0: 'Medicine',
  1: 'Behavior', 
  2: 'Other',
};

// Day names for repeat functionality
export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Utility functions
export const getDaysFromRepeatDays = (repeatDays) => {
  const days = [];
  for (let i = 0; i < 7; i++) {
    if (repeatDays & (1 << i)) {
      days.push(DAY_NAMES[i]);
    }
  }
  return days;
};

export const getRepeatDaysFromArray = (daysArray) => {
  let repeatDays = null; // Initialize to 0 instead of null
  daysArray.forEach(day => {
    const index = DAY_NAMES.indexOf(day);
    if (index !== -1) {
      repeatDays |= (1 << index);
    }
  });
  return repeatDays;
};

// Convert day names to DayOfWeek enum numbers (0=Sunday, 1=Monday, etc.)
export const getDayOfWeekNumbers = (daysArray) => {
  const dayMapping = {
    'Sun': 0,  // Sunday
    'Mon': 1,  // Monday
    'Tue': 2,  // Tuesday
    'Wed': 3,  // Wednesday
    'Thu': 4,  // Thursday
    'Fri': 5,  // Friday
    'Sat': 6   // Saturday
  };

  return daysArray.map(day => dayMapping[day]).filter(num => num !== undefined);
};

// Convert DayOfWeek enum numbers back to day names
export const getDaysFromDayOfWeekNumbers = (dayNumbers) => {
  const numberMapping = {
    0: 'Sun',  // Sunday
    1: 'Mon',  // Monday
    2: 'Tue',  // Tuesday
    3: 'Wed',  // Wednesday
    4: 'Thu',  // Thursday
    5: 'Fri',  // Friday
    6: 'Sat'   // Saturday
  };

  if (!Array.isArray(dayNumbers)) return [];
  return dayNumbers.map(num => numberMapping[num]).filter(day => day !== undefined);
};

// Transform API response to match component expectations
export const transformScheduleData = (apiData) => {
  return apiData.map(schedule => ({
    ...schedule,
    reminderTimes: schedule.reminderTimesJson ? 
      JSON.parse(schedule.reminderTimesJson) : [],
    // Add displayDays for backward compatibility
    displayDays: schedule.reminderDays ? getDaysFromDayOfWeekNumbers(schedule.reminderDays) : []
  }));
};

// Schedule API service
export const scheduleApiService = {
  // Add new schedule and assign to user
  assignSchedule: async (scheduleData) => {
    try {
      const response = await drEasyApi.post('/api/Schedule/Assign', scheduleData);
      return response.data;
    } catch (error) {
      message.info(error.response.data.errors[0])
      console.error('Assign schedule error:', error);
      throw error("Faild To Assign Scheduel")
    }
  },

  // Edit existing schedule
  editSchedule: async (scheduleData) => {
    try {
      const response = await drEasyApi.put('/api/Schedule/Edit', scheduleData);
      return response.data;
    } catch (error) {
      console.error('Edit schedule error:', error);
      throw new Error(error.response?.data?.message || 'Failed to update schedule');
    }
  },

  // Delete schedule
  deleteSchedule: async (scheduleId) => {
    try {
      const response = await drEasyApi.delete(`/api/Schedule/Delete?ScheduleItemId=${scheduleId}`);
      return response.data;
    } catch (error) {
      console.error('Delete schedule error:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete schedule');
    }
  },

  // Get user schedules
  getUserSchedules: async (userId) => {
    try {
      const response = await drEasyApi.get('/api/Schedule/GetUserSchedules', {
        params: { UserId: userId },
      });
      return transformScheduleData(response.data || []);
    } catch (error) {
      console.error('Get user schedules error:', error);
      throw new Error('Failed to load schedules');
    }
  }
};